import { generateClasses } from '../../../utils/helper';

export const insertFormulaButtonClasses = generateClasses('InsertFormulaButton', [
  'toolbarButton',
  'formula',
  'toolbarIcon',
  'formulaIcon',
]);
